"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var CollapseIcon = function CollapseIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 11V8.56l5-3.501 5 3.5V11L6 8.2l-1-.657-1 .656L0 11Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 6V3.56L5 .058l5 3.5V6L6 3.2l-1-.657-1 .656L0 6Z"
  }));
};
CollapseIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg"
};
var styles = {
  "collapse-button": "CollapseButton__collapse-button__1n5nh",
  "collapseButton": "CollapseButton__collapse-button__1n5nh",
  "button": "CollapseButton__button__2FTUd"
}; 
require('./CollapseButton.css');
var CollapseButton = function CollapseButton(_ref) {
  var onClick = _ref.onClick,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    _ref$isFocused = _ref.isFocused,
    isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused;
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    position: "left",
    content: "Collapse"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "collapse-section",
    isFocused: isFocused,
    type: "button",
    testId: "collapse-section-button",
    onClick: onClick,
    disabled: isDisabled,
    "aria-label": "Collapse section to see less options",
    "aria-describedby": "collapse-section-description",
    className: (0, _classnames.default)(styles.collapseButton, styles.button),
    noFill: true,
    size: "sm",
    kind: null
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: "collapse-section-description",
    className: "visually-hidden"
  }, "Collapse section to see less options"), /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "xxs"
  }, /*#__PURE__*/_react.default.createElement(CollapseIcon, null))));
};
var _default = exports.default = CollapseButton;
//# sourceMappingURL=CollapseButton.js.map